
import { Service } from "@/types/marketplace";

export const marketplaceData: Service[] = [
  {
    id: 1,
    title: "Full-Stack Development",
    price: "From $75/day",
    seller: "Alex Morgan",
    rating: 4.9,
    reviews: 128,
    description: "Expert full-stack development services using modern technologies.",
    skills: ["React", "Node.js", "MongoDB"],
    iconName: "Code",
    availability: "Immediate",
    completedProjects: 85,
    responseTime: "< 2 hours",
    location: "San Francisco, CA",
    verified: true
  },
  {
    id: 2,
    title: "UI/UX Design",
    price: "From $60/day",
    seller: "Sarah Chen",
    rating: 4.8,
    reviews: 95,
    description: "Professional UI/UX design services for web and mobile applications.",
    skills: ["Figma", "Adobe XD", "Prototyping"],
    iconName: "Paintbrush",
    availability: "Next Week",
    completedProjects: 64,
    responseTime: "< 4 hours",
    location: "New York, NY",
    verified: true
  },
  {
    id: 3,
    title: "Database Architecture",
    price: "From $85/day",
    seller: "Mike Peterson",
    rating: 4.9,
    reviews: 73,
    description: "Expert database design and optimization services.",
    skills: ["PostgreSQL", "MongoDB", "Redis"],
    iconName: "Database",
    availability: "Immediate",
    completedProjects: 92,
    responseTime: "< 1 hour",
    location: "London, UK",
    verified: true
  },
  {
    id: 4,
    title: "International SEO",
    price: "From $65/day",
    seller: "Emma Wilson",
    rating: 4.7,
    reviews: 84,
    description: "Comprehensive SEO services for international markets.",
    skills: ["SEO", "Content Strategy", "Analytics"],
    iconName: "Globe",
    availability: "Next Week",
    completedProjects: 71,
    responseTime: "< 3 hours",
    location: "Toronto, CA",
    verified: false
  },
  {
    id: 5,
    title: "Cloud Architecture",
    price: "From $95/day",
    seller: "David Chen",
    rating: 4.9,
    reviews: 112,
    description: "Expert cloud architecture and DevOps services for scalable applications.",
    skills: ["AWS", "Azure", "DevOps"],
    iconName: "Cloud",
    availability: "Next Week",
    completedProjects: 78,
    responseTime: "< 4 hours",
    location: "Seattle, WA",
    verified: true,
    languages: ["English", "Mandarin"],
    expertise: "Senior Cloud Architect"
  },
  {
    id: 6,
    title: "Mobile App Development",
    price: "From $80/day",
    seller: "Lisa Johnson",
    rating: 4.8,
    reviews: 94,
    description: "Professional mobile app development for iOS and Android platforms.",
    skills: ["React Native", "Flutter", "Swift"],
    iconName: "Laptop",
    availability: "Immediate",
    completedProjects: 56,
    responseTime: "< 3 hours",
    location: "Austin, TX",
    verified: true,
    videoIntro: "https://example.com/video",
    expertise: "Mobile Development Lead"
  },
  {
    id: 7,
    title: "Data Analytics",
    price: "From $70/day",
    seller: "James Wilson",
    rating: 4.7,
    reviews: 83,
    description: "Comprehensive data analytics and visualization services.",
    skills: ["Python", "R", "Tableau"],
    iconName: "LineChart",
    availability: "Next Week",
    completedProjects: 62,
    responseTime: "< 5 hours",
    location: "Chicago, IL",
    verified: false,
    languages: ["English", "Spanish"],
    expertise: "Data Scientist"
  },
  {
    id: 8,
    title: "Technical Writing",
    price: "From $55/day",
    seller: "Rachel Brown",
    rating: 4.8,
    reviews: 76,
    description: "Professional technical documentation and content writing services.",
    skills: ["Documentation", "API Docs", "Content"],
    iconName: "FileCode",
    availability: "Immediate",
    completedProjects: 45,
    responseTime: "< 2 hours",
    location: "Portland, OR",
    verified: true,
    languages: ["English", "French"],
    expertise: "Senior Technical Writer"
  },
  {
    id: 9,
    title: "IT Consulting",
    price: "From $90/day",
    seller: "Mark Thompson",
    rating: 4.9,
    reviews: 88,
    description: "Strategic IT consulting and digital transformation services.",
    skills: ["Strategy", "Architecture", "Management"],
    iconName: "Presentation",
    availability: "Next Week",
    completedProjects: 92,
    responseTime: "< 6 hours",
    location: "Miami, FL",
    verified: true,
    videoIntro: "https://example.com/video2",
    expertise: "IT Strategy Consultant"
  },
  {
    id: 10,
    title: "Network Security",
    price: "From $85/day",
    seller: "Sarah Lee",
    rating: 4.8,
    reviews: 67,
    description: "Comprehensive network security and penetration testing services.",
    skills: ["Security", "Penetration Testing", "Firewalls"],
    iconName: "Wifi",
    availability: "Immediate",
    completedProjects: 71,
    responseTime: "< 3 hours",
    location: "Boston, MA",
    verified: true,
    languages: ["English", "Korean"],
    expertise: "Security Specialist"
  }
];
